import { getAtPath } from 'app/utilities';
import { startCase } from 'lodash';
import * as React from 'react';
import { RegisterOptions, useFormContext } from 'react-hook-form';
import { TextField, TextFieldProps } from 'app/design-lib';

interface HookFormTextFieldProps extends Omit<TextFieldProps, 'name'> {
  name: string;
  errorField?: string;
  errorMessageParser?: (error: any) => string;
  options?: RegisterOptions;
}

const HookFormTextField = ({
  name,
  errorField,
  label,
  errorMessageParser,
  options,
  ...props
}: HookFormTextFieldProps) => {
  const {
    register,
    formState: { errors: formErrors },
  } = useFormContext();

  const error = getAtPath(formErrors, errorField || name);

  const errorMessage = error
    ? errorMessageParser
      ? errorMessageParser(error)
      : error.message
    : undefined;

  return (
    <TextField
      label={label}
      {...props}
      {...register(name, options)}
      hasError={!!errorMessage}
      helperText={
        errorMessage?.replace(`"${name}"`, startCase(name)) ?? props.helperText
      }
    />
  );
};

export default HookFormTextField;
